export interface RawPlatformState {
  readonly platform_state: PlatformStateEnum;
  readonly message_kind: string;
  readonly published_at?: number;
  readonly next_platform_state: PlatformStateEnum;
  readonly next_platform_state_at?: number;
}

export interface PlatformState {
  readonly platformState: PlatformStateEnum;
  readonly messageKind: string;
  readonly publishedAt?: number;
  readonly nextPlatformState: PlatformStateEnum;
  readonly nextPlatformStateAt?: number;
}

export interface ParsedPlatformState {
  readonly platformState: ParsedPlatformStateEnum;
  readonly messageKind: string;
  readonly publishedAt?: string;
  readonly nextPlatformState: ParsedPlatformStateEnum;
  readonly nextPlatformStateAt?: string;
}

export const platformStateValues = {
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
  AVAILABLE_CANCEL_ONLY: 'AVAILABLE_CANCEL_ONLY',
} as const;

export const parsedPlatformStateValues = {
  AVAILABLE: 'Ready for Trading',
  UNAVAILABLE: 'Unavailable',
  AVAILABLE_CANCEL_ONLY: 'Available Cancel-Only',
} as const;

export type PlatformStateEnum =
  typeof platformStateValues[keyof typeof platformStateValues];

export type ParsedPlatformStateEnum =
  typeof parsedPlatformStateValues[keyof typeof platformStateValues];
